import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const CollapseTopIcon = (props) => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <path
      d="M4.16667 17.5L15.8333 17.5C16.7525 17.5 17.5 16.7525 17.5 15.8333L17.5 4.16667C17.5 3.2475 16.7525 2.5 15.8333 2.5L4.16667 2.5C3.2475 2.5 2.5 3.2475 2.5 4.16667L2.5 15.8333C2.5 16.7525 3.2475 17.5 4.16667 17.5ZM10.5892 7.74417L13.9225 11.0775C14.2475 11.4025 14.2475 11.9308 13.9225 12.2558C13.5975 12.5808 13.0692 12.5808 12.7442 12.2558L10 9.51167L7.25583 12.2558C6.93083 12.5808 6.4025 12.5808 6.0775 12.2558C5.7525 11.9308 5.7525 11.4025 6.0775 11.0775L9.41083 7.74417C9.73583 7.41833 10.2642 7.41833 10.5892 7.74417Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

CollapseTopIcon.propTypes = {
  sx: PropTypes.object,
};

export default CollapseTopIcon;
